/**
 * Navbar
 */

import Cart from 'components/cart';
import { Wrapper } from './elements';
import Logo from 'assets/images/logo.png';
import mLogo from 'assets/images/mLogo.png';
import { useWindowSize } from 'utils/hooks';
import Container from 'components/container';
import { useStateValue } from 'context/store';
import { withRouter, Link } from 'react-router-dom';
import { useTheme } from 'context/theme/themeContext';
import React, { Fragment, lazy, Suspense } from 'react';
import mookhLightLogo from 'assets/images/logo-grey.png';
import mookhDarkLogo from 'assets/images/logo-yellow.png';
import mookhMobileLogo from 'assets/images/m-logo-grey.png';
//import WhiteLogo from 'assets/images/logo-white.png';

const DesktopMenus = lazy(() =>
  import(/* webpackChunkName: "DesktopMenus" */ './DesktopMenus')
);

const MobileMenus = lazy(() =>
  import(/* webpackChunkName: "MobileMenus" */ './MobileMenus')
);

export const SearchResultsOverlay = lazy(() =>
  import(
    /* webpackChunkName: "SearchResultsOverlay" */ 'containers/SearchResultsOverlay'
  )
);

export function Navbar(props) {
  const { themeMode } = useTheme();
  const { width } = useWindowSize();
  const {
    state: { tabs }
  } = useStateValue();
  const { tabIndex, profileTabIndex, termsIndex } = tabs;
  sessionStorage.setItem('tabIndex', JSON.stringify(tabIndex));
  sessionStorage.setItem('termsIndex', JSON.stringify(termsIndex));
  sessionStorage.setItem('profileTabIndex', JSON.stringify(profileTabIndex));

  return (
    <Fragment>
      <SearchResultsOverlay />
      <Wrapper>
        <Container>
          <div className="color">
            <Link to="/">
              {width > 768 ? (
                <img
                  alt="MOOKH's Mobile Logo"
                  style={{ maxWidth: 150, width: '80%' }}
                  src={themeMode === 'dark' ? mookhDarkLogo : mookhLightLogo}
                />
              ) : (
                <img
                  src={mookhMobileLogo}
                  alt="MOOKH's Mobile Logo"
                  style={{ margin: 0, width: '50%' }}
                />
              )}
            </Link>
            <Suspense fallback={<div>{null}</div>}>
              <DesktopMenus width={width} {...props} />
              <MobileMenus width={width} {...props} />
              <Cart />
            </Suspense>
          </div>
        </Container>
      </Wrapper>
    </Fragment>
  );
}

export default withRouter(Navbar);
